import { MOCK_PULSE, CURRENT_USER } from "@/lib/mockData";

const DailyPulseCard = () => {
  const p = MOCK_PULSE;
  return (
    <div className="brutal-card p-5 bg-[#FFFBEB]" data-testid="daily-pulse-card">
      <div className="flex items-center justify-between mb-3">
        <span className="label-mono">Today's Pulse</span>
        <span className="font-mono text-xs text-[#555555]">
          {new Date().toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" })}
        </span>
      </div>
      <h2 className="font-heading font-black text-2xl mb-3 leading-tight">
        {p.available_now} people are <span className="text-[#FF6A2C]">live nearby</span> right now.
      </h2>
      <p className="text-sm text-[#555555] mb-4">
        {p.activities_next_90min} activities kicking off in the next 90 min. {p.spots_opened} fresh spots just opened up.
        You&apos;ve got <span className="font-bold text-[#0A0A0A]">{CURRENT_USER.tokens} tokens</span>.
      </p>
      <div className="flex gap-2 items-center text-xs font-bold uppercase tracking-wide text-[#0A0A0A]">
        <span className="w-2 h-2 bg-[#34C759] rounded-full" />
        Don&apos;t sit on those tokens — grabb something.
      </div>
    </div>
  );
};

export default DailyPulseCard;
